module.exports = __webpack_public_path__ + "img/product-icon1.0af08137.png";